import axios from 'axios';

const isRequestCanceledError = (error) => {
  return axios.isCancel(error);
};

export { isRequestCanceledError };
